export const saveTabAction = (index) => {
    return {
        type:'SELECT_INDEX',
        payload:index
    }
}